import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import { Subtitle } from '../forms/Title';
import SelectDropdownMenu from '../forms/SelectDropdownMenu';
import gt_map_location from '../../assets/img/gt_map_location.png';

const StartSection = () => {
  const styles = {
    content: {
      paddingLeft: {
        xs: 'calc(2vw)',
        lg: 'calc(2.2vw)',
      },
      paddingBottom: {
        xs: 'calc(10vw)',
        sm: 'calc(4vw)',
        md: 'calc(4vw)',
        lg: 'calc(11vw)',
      },
    },
    title: {
      marginBottom: 'calc(3vh)',
      marginRight: 'calc(10vw)',
      paddingRight: 'calc(10vw)',
      marginTop: 'calc(2vw)',
    },
    locationImage: {
      marginBottom: 'calc(1%)',
      marginTop: { xs: 'calc(5vh)', sm: 'calc(3vh)' },
      display: {
        lg: 'none',
      },
      overflowX: 'hidden',
    },
    // link: {
    //   color: palette.cyan_blue,
    //   textDecoration: 'none',
    // },
    // text: {
    //   typography: { xs: 'body2', sm: 'body1' },
    //   my: 'calc(1vh)',
    // },
  };

  return (
    <Grid container sx={styles.content}>
      <Grid item sm={12}>
        <Box sx={styles.title}>
          <Subtitle title="Ready to start?" />
        </Box>
      </Grid>
      <Grid item xs={12} sm={5} lg={6}>
        <Stack spacing={5}>
          <SelectDropdownMenu name="audience" data-testid="audience_dropdown" />
        </Stack>
      </Grid>
      <Grid item xs={12} sm={7} sx={styles.locationImage}>
        <img
          src={gt_map_location}
          id="gt_map_location"
          alt="GT map location"
          width="110%"
          data-testid="gt-map-location-test"
        />
      </Grid>
    </Grid>
    /* <Grid item xs={12}>
          <Typography sx={StartSectionStyles.text}>
            <Link href="#" sx={StartSectionStyles.link}>
              Log in{' '}
            </Link>
            to your GroundTruth Ads Manager account? Or{' '}
            <Link href="#" sx={StartSectionStyles.link}>
              create an account.
            </Link>
          </Typography>
        </Grid> */
  );
};

export default StartSection;
